import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withKeys as _withKeys, normalizeClass as _normalizeClass, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "dashboardView" }
const _hoisted_2 = { class: "mainTitle" }
const _hoisted_3 = { class: "topLinks" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_3x3 icon" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_message icon" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_plus icon" }, null, -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "messageNotificationTitle" }
const _hoisted_9 = { class: "messagesContainer" }
const _hoisted_10 = { class: "messages" }
const _hoisted_11 = { class: "notifications" }
const _hoisted_12 = { class: "notice mobile" }
const _hoisted_13 = {
  key: 1,
  class: "errorEmpty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_FeedbackThread = _resolveComponent("FeedbackThread")!
  const _component_InfinityScroll = _resolveComponent("InfinityScroll")!
  const _component_Thread = _resolveComponent("Thread")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t("tell_city_view.title")), 1),
    _createElementVNode("ul", _hoisted_3, [
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          class: "button",
          to: { name: 'Feedbacks' }
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("tell_city_view.feedbacks")), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          class: "button",
          to: { name: 'Contact' }
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("tell_city_view.contact")), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          class: "button filled",
          to: { name: 'FeedbackSubmit' }
        }, {
          default: _withCtx(() => [
            _hoisted_6,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("tell_city_view.submit_notification")), 1)
          ]),
          _: 1
        })
      ])
    ]),
    (_ctx.feedbacks.data.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.$t("tell_city_view.my_messages")), 1),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_InfinityScroll, {
                onLoadNextPage: _ctx.getFeedbacks,
                data: _ctx.feedbacks,
                loading: _ctx.isLoading
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeFeedbacks, (feedback) => {
                      return (_openBlock(), _createBlock(_component_FeedbackThread, {
                        tabindex: "0",
                        onKeyup: _withKeys(($event: any) => (_ctx.selectFeedback(feedback)), ["enter"]),
                        onToggled: _ctx.toggleMobileThread,
                        key: feedback.id,
                        feedback: feedback,
                        onClick: ($event: any) => (_ctx.selectFeedback(feedback)),
                        class: _normalizeClass({ selected: _ctx.selectedFeedback?.id === feedback.id })
                      }, null, 8, ["onKeyup", "onToggled", "feedback", "onClick", "class"]))
                    }), 128)),
                    (_ctx.finishedFeedbacks.length > 0)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("b", null, _toDisplayString(_ctx.$t("tell_city_view.finished")), 1),
                          _createTextVNode(": "),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.finishedFeedbacks, (feedback) => {
                            return (_openBlock(), _createBlock(_component_FeedbackThread, {
                              tabindex: "0",
                              onKeyup: _withKeys(($event: any) => (_ctx.selectFeedback(feedback)), ["enter"]),
                              onToggled: _ctx.toggleMobileThread,
                              key: feedback.id,
                              feedback: feedback,
                              onClick: ($event: any) => (_ctx.selectFeedback(feedback)),
                              class: _normalizeClass({ selected: _ctx.selectedFeedback?.id === feedback.id })
                            }, null, 8, ["onKeyup", "onToggled", "feedback", "onClick", "class"]))
                          }), 128))
                        ], 64))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }, 8, ["onLoadNextPage", "data", "loading"])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["messageContent", { show: _ctx.mobileThreadVisible }])
            }, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("span", {
                  class: "icon-warpit_icon_arrow-L icon",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMobileThread && _ctx.toggleMobileThread(...args)))
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("feedback.notice")), 1)
              ]),
              _createVNode(_component_Thread)
            ], 2)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t("feedback.no_feedbacks")), 1)
        ]))
  ]))
}